// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + "c486ff9f3f6eefb29595" + ".bundle.js";
};